/* eslint-disable sort-keys */
export const SalesStatus = {
  None: 0,
  Open_or_Backorder: 1,
  Delivered: 2,
  Invoiced: 3,
  Cancelled: 4
} as const;
